import { render, staticRenderFns } from "./SendRequest.vue?vue&type=template&id=71bf16ca"
import script from "./SendRequest.vue?vue&type=script&lang=ts"
export * from "./SendRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports